// removed by extract-text-webpack-plugin
module.exports = {"root":"root__1g6XB","user-image":"user-image__3d74O","dropzone":"dropzone__1_FDC","preview":"preview__2K-kZ","delete":"delete__20uMU","user-form":"user-form__24w1S"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/UserAccount/styles.scss
// module id = ./app/scripts/views/App/views/UserAccount/styles.scss
// module chunks = 1